import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useSearchTileLiveLotPositionExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.SearchTileLiveLotPosition,
        AmplitudeVariants.SearchTileLiveLotPosition.Treatment
    );
